import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './WritingExam.css';
import API_BASE_URL from '../config';

const WritingExam = () => {
    const { testId } = useParams();
    const navigate = useNavigate();
    const user = JSON.parse(localStorage.getItem('user'));
    const [zoomLevel, setZoomLevel] = useState(100);
    const [exam, setExam] = useState(null);
    // 🔥 FIX: loading state chuẩn
    const [loading, setLoading] = useState(true);
    const [timeLeft, setTimeLeft] = useState(3600);
    const [activeTask, setActiveTask] = useState(1);
    const [contents, setContents] = useState({
        task1: '',
        task2: ''
    });
    // =========================
    // FETCH EXAM
    // =========================
    useEffect(() => {
        const fetchExam = async () => {
            try {
                setLoading(true);

                console.log("📡 Đang gọi API với testId:", testId);
                const url =
                    `${API_BASE_URL}/api/exam-data/exams/detail-writing/${testId}`;
                console.log("🌐 URL:", url);
                const res = await axios.get(url);
                console.log("✅ DATA API:", res.data);
                // 🔥 FIX: kiểm tra dữ liệu rỗng
                if (
                    !res.data ||
                    res.data.message ||
                    Object.keys(res.data).length === 0
                ) {
                    console.log("❌ Không có dữ liệu exam");
                    setExam(null);
                    return;
                }
                setExam(res.data);
    
            } catch (err) {
                console.error("❌ Lỗi tải đề thi:", err);
                setExam(null);
            } finally {
                setLoading(false);
            }
        };
        if (testId) {
            fetchExam();
        }
    }, [testId]);
    // =========================
    // TIMER
    // =========================
    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(prev => {
                if (prev <= 1) {
                    clearInterval(timer);
                    alert("Time's up!");
                    handleSubmit();
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
        return () => clearInterval(timer);
    }, []);
    // =========================
    // FORMAT TIME
    // =========================
    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
    };
    // =========================
    // WORD COUNT
    // =========================
    const getWordCount = (text) => {
        const words = text.trim().split(/\s+/);
        return text.trim() === ''
            ? 0
            : words.length;
    };
    // =========================
    // HANDLE TEXT CHANGE
    // =========================
    const handleTextChange = (e) => {
        const { value } = e.target;
        setContents(prev => ({
            ...prev,
            [activeTask === 1 ? 'task1' : 'task2']: value
        }));
    };
    // =========================
    // SUBMIT
    // =========================
    const handleSubmit = async () => {

        if (
            !contents.task1.trim() &&
            !contents.task2.trim()
        ) {
            return alert("Please submit your work!");
        }

        setLoading(true);

        try {

            const response = await axios.post(
                `${API_BASE_URL}/api/submit-writing`,
                {
                    user_id: user?.id || user?.user_id,
                    test_id: testId,
                    fullname: user?.fullname,
                    student_email: user?.email,
                    content:
                        `--- TASK 1 ---\n${contents.task1}\n\n--- TASK 2 ---\n${contents.task2}`
                }
            );
            if (response.data.success) {

                alert("🎉 Submission successful!");
                navigate('/dashboard');
            }
        } catch (err) {
            console.error(err);
            alert("An error occurred during the assignment submission process.");
        } finally {
            setLoading(false);
        }
    };
    // =========================
    // HIGHLIGHT
    // =========================
    const handleHighlight = () => {
        const selection = window.getSelection();
        if (
            selection.rangeCount > 0 &&
            selection.toString().trim().length > 0
        ) {
            const range = selection.getRangeAt(0);
            const mark = document.createElement('mark');
            mark.style.backgroundColor = '#ffeb3b';
            mark.style.color = 'black';
            try {
                range.surroundContents(mark);
            } catch (e) {
                alert(
                    "Please select only the text that is within the same paragraph."
                );
            }
            selection.removeAllRanges();
        }
    };
    // =========================
    // LOADING UI
    // =========================
    if (loading) {

        return (
            <div className="loading">
                Đang tải đề thi...
            </div>
        );
    }
    // =========================
    // ERROR UI
    // =========================
    if (!exam) {

        return (
            <div
                className="loading"
                style={{
                    color: 'red',
                    padding: '20px',
                    fontWeight: 'bold'
                }}
            >
                ❌ Không tìm thấy đề thi
            </div>
        );
    }
    // =========================
    // DEBUG
    // =========================
    console.log("🧪 exam:", exam);
    // =========================
    // URLS
    // =========================
    const imageUrl =
        exam?.image_url ||
        exam?.imageUrl ||
        exam?.image;

    const audioUrl =
        exam?.audio_url ||
        exam?.audioUrl ||
        exam?.audio;
    
    /* ================= FIX LỖI GHÉP URL DƯ DẤU GẠCH CHÉO // ================= */
    const getFullUrl = (url) => {
        if (!url) return null;
        if (url.startsWith('http')) {
            return url;
        }
        
        // Loại bỏ dấu gạch chéo ở cuối API_BASE_URL nếu có
        const cleanBaseUrl = API_BASE_URL.endsWith('/') 
            ? API_BASE_URL.slice(0, -1) 
            : API_BASE_URL;

        // Loại bỏ dấu gạch chéo ở đầu url nếu có để tự ghép thủ công chuẩn xác
        const cleanRelativeUrl = url.startsWith('/') ? url : '/' + url;

        return `${cleanBaseUrl}${cleanRelativeUrl}`;
    };

    return (

        <div className="writing-page-wrapper">

            {/* HEADER */}
            <div className="quiz-header">

                <div className="user-info">
                    <span className="user-icon">👤</span>

                    {user?.fullname || "Candidate"} - {" "}
                    {user?.id || user?.user_id || "123456"}
                </div>

                <div className="timer-container">

                    <span className="timer-box">
                        ⏰ <strong>{formatTime(timeLeft)}</strong> minutes left
                    </span>

                </div>

                <div className="header-actions">

                    <button className="btn-help">
                        Help ❓
                    </button>

                    <button className="btn-hide">
                        Hide 👁
                    </button>

                </div>
            </div>

            {/* MAIN */}
            <div className="writing-container">

                {/* LEFT */}
                <div className="exam-sidebar">

                    <h2>
                        {activeTask === 1
                            ? "Writing Task 1"
                            : "Writing Task 2"}
                    </h2>

                    <p className="test-id-label">
                        Mã đề: {testId}
                    </p>

                    <hr />

                    {/* TOOLS */}
                    <div
                        style={{
                            display: 'flex',
                            gap: '10px',
                            marginBottom: '10px',
                            paddingBottom: '10px',
                            borderBottom: '1px solid #eee',
                            background: '#fff'
                        }}
                    >

                        <button
                            onClick={() =>
                                setZoomLevel(z =>
                                    Math.min(z + 10, 200)
                                )
                            }
                        >
                            ➕ Zoom In
                        </button>

                        <button
                            onClick={() =>
                                setZoomLevel(z =>
                                    Math.max(z - 10, 80)
                                )
                            }
                        >
                            ➖ Zoom Out
                        </button>

                        <button
                            onClick={handleHighlight}
                            style={{
                                backgroundColor: '#ffeb3b',
                                border: '1px solid #ccc'
                            }}
                        >
                            🖍 Highlight
                        </button>

                        <span
                            style={{
                                fontSize: '12px',
                                color: '#666'
                            }}
                        >
                            Zoom: {zoomLevel}%
                        </span>
                    </div>

                    {/* IMAGE */}
                    {activeTask === 1 && imageUrl ?
                        (

                            <div className="image-wrapper">

                                <img
                                    src={getFullUrl(imageUrl)}
                                    alt="Đề bài Writing"
                                    className="exam-image"
                                />

                            </div>

                        ) : activeTask === 1 ?
                        (

                            <p style={{ color: 'red' }}>
                                ⚠️ Không có ảnh
                            </p>

                        ) : null}

                    {/* AUDIO */}
                    {audioUrl && (

                        <div style={{ margin: '10px 0' }}>

                            {/* 🔥 FIX: Gán key hoặc src trực tiếp để trình duyệt cập nhật lại Player khi đổi audio */}
                            <audio controls key={audioUrl}>
                                <source src={getFullUrl(audioUrl)} />
                            </audio>

                        </div>
                    )}

                    {/* CONTENT */}
                    <div
                        className="exam-description"
                        style={{
                            fontSize: `${zoomLevel}%`,
                            transition:
                                'font-size 0.2s ease-in-out'
                        }}
                    >

                        {exam.content &&
                        exam.content.includes('[split]') ?
                            (
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html:
                                            activeTask === 1
                                                ? exam.content.split('[split]')[0]
                                                : exam.content.split('[split]')[1]
                                    }}
                                />
                            ) : (
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html:
                                            exam.content ||
                                            "<p>Không có nội dung</p>"
                                    }}
                                />
                            )}

                    </div>
                </div>
                {/* RIGHT */}
                <div className="workspace">
                    <div className="workspace-header">
                        <h3>
                            Your work - Task {activeTask}
                        </h3>
                        <span
                            className={`word-count ${
                                getWordCount(
                                    activeTask === 1
                                        ? contents.task1
                                        : contents.task2
                                ) < 150
                                    ? 'warning'
                                    : 'success'
                            }`}
                        >
                            Số từ: {
                                getWordCount(
                                    activeTask === 1
                                        ? contents.task1
                                        : contents.task2
                                )
                            }
                        </span>
                    </div>
                    <textarea
                        className="writing-textarea"
                        value={
                            activeTask === 1
                                ? contents.task1
                                : contents.task2
                        }
                        onChange={handleTextChange}
                    />
                </div>
            </div>
            {/* FOOTER */}
            <div className="quiz-footer">
                <div className="question-navigation">
                    <button
                        className={`q-btn ${
                            activeTask === 1
                                ? 'active'
                                : ''
                        }`}
                        onClick={() => setActiveTask(1)}
                    >
                        1
                    </button>
                    <button
                        className={`q-btn ${
                            activeTask === 2
                                ? 'active'
                                : ''
                        }`}
                        onClick={() => setActiveTask(2)}
                    >
                        2
                    </button>
                </div>
                <button
                    className="finish-btn"
                    onClick={handleSubmit}
                >
                    Finish Test
                </button>
            </div>
        </div>
    );
};

export default WritingExam;